import {Component} from "@angular/core";
import {environment} from "../config/environment";

@Component({
  selector: 'app-environment',
  template: `
    <ion-item *ngIf="env.name !== 'live'">
      <ion-label>
        Environment
      </ion-label>
      <div item-content>
        {{ env.name }}
      </div>
    </ion-item>
  `,
})
export class EnvironmentComponent {
  version: string;
  env;

  constructor() {
    this.env = environment;
  }


}



// WEBPACK FOOTER //
// ./src/app/components/environment.component.ts